import { IMeta, IPagination, ISort } from "@delanobgt/admin-core/util/types";
import { produce } from "immer";
import { Reducer } from "redux";
import {
  EProductCategorySortField,
  IProductCategory,
  PProductCategoryFilter,
} from "src/core/productCategory/entities";
import { ActionType, createAction, getType } from "typesafe-actions";

/*
 * state
 */
export interface IProductCategoryState {
  productCategorys: IProductCategory[];
  loading: boolean;
  error: any;
  meta: IMeta;
}

const initialState: IProductCategoryState = {
  productCategorys: [],
  loading: false,
  error: null,
  meta: {
    limit: 10,
    offset: 0,
    total: 0,
  },
};

/*
 * action types
 */
const FETCH_REQUESTED = "product-category/FETCH_REQUESTED";
const FETCH_SUCCEEDED = "product-category/FETCH_SUCCEEDED";
const FETCH_FAILED = "product-category/FETCH_FAILED";
const POLLING_START_REQUESTED = "product-category/POLLING_START_REQUESTED";
const POLLING_STOP_REQUESTED = "product-category/POLLING_STOP_REQUESTED";

/*
 * action creators
 */
export const actions = {
  fetchRequested: createAction(FETCH_REQUESTED)(),

  fetchSucceeded: createAction(FETCH_SUCCEEDED)<{
    data: IProductCategory[];
    meta: IMeta;
  }>(),

  fetchFailed: createAction(FETCH_FAILED)<any>(),

  pollingStartRequested: createAction(POLLING_START_REQUESTED)<{
    filter: PProductCategoryFilter;
    pagination: IPagination;
    sorts: ISort<EProductCategorySortField>[];
    refreshDelay: number;
  }>(),

  pollingStopRequested: createAction(POLLING_STOP_REQUESTED)(),
};
export type TActions = ActionType<typeof actions>;

const reducer: Reducer<IProductCategoryState, TActions> = (
  state = initialState,
  action
) => {
  return produce<IProductCategoryState>(state, (draft) => {
    switch (action.type) {
      case getType(actions.fetchRequested): {
        draft.loading = true;
        draft.error = null;
        break;
      }
      case getType(actions.fetchSucceeded): {
        const {
          payload: { data, meta },
        } = action;
        draft.productCategorys = data;
        draft.loading = false;
        draft.error = null;
        draft.meta = meta;
        break;
      }
      case getType(actions.fetchFailed): {
        const { payload } = action;
        draft.loading = false;
        draft.error = payload;
        break;
      }
    }
  });
};

export default reducer;
